import React from "react";
import './footer.css'

// ...... images .......
import bird from '../../assets/images/twitter.svg';
import linked from '../../assets/images/linkedin.svg';
import mail from '../../assets/images/mail.svg';
import phone from '../../assets/images/phone.svg';
import {NavHashLink} from "react-router-hash-link";

function Footer() {
   return (
       <footer className="footer">
          <div className="content-box">
             <ul className="footer-columns flex hr-space-between align-top">
                <li className={'social-column'}>
                   <div className="rubik-bold font-22 highlight-color margin-b-30">Floik</div>
                   <div className="flex">
                      <div className="icon">
                         <img src={bird} alt=""/>
                      </div>
                      <div className="icon margin-l-20">
                         <img src={linked} alt=""/>
                      </div>
                   </div>
                </li>

                <li className="platform-column">
                   <div className="nav-title">Platform</div>
                   <ul className="footer-navs">
                      <li>
                         <NavHashLink to={'/home/#how-it-works'}
                                      scroll={(el) => el.scrollIntoView({behavior: 'smooth'})}>
                            How it works
                         </NavHashLink>
                      </li>
                      <li>
                         <NavHashLink to={'/home/#features'}
                                      scroll={(el) => el.scrollIntoView({behavior: 'smooth'})}>
                            Features
                         </NavHashLink>
                      </li>
                      <li>
                         <NavHashLink to={'/home/#interactive-videos'}
                                      scroll={(el) => el.scrollIntoView({behavior: 'smooth'})}>
                            Interactive videos
                         </NavHashLink>
                      </li>
                      <li>
                         <NavHashLink to={'/home/#integrations'}
                                      scroll={(el) => el.scrollIntoView({behavior: 'smooth'})}>
                            Integrations
                         </NavHashLink>
                      </li>
                      <li>
                         <a className="flex hr-space-between">
                            <span className="">How To GIF</span>
                            <span className="coming-soon">Coming soon</span>
                         </a>
                      </li>
                      <li>
                         <a className="flex hr-space-between">
                            <span className="">Customised demo</span>
                            <span className="coming-soon">Coming soon</span>
                         </a>
                      </li>
                      <li>
                         <a className="flex hr-space-between">
                            <span className="">Self Guided Tour</span>
                            <span className="coming-soon">Coming soon</span>
                         </a>
                      </li>
                   </ul>
                </li>

                <li className="">
                   <div className="nav-title">Solutions</div>
                   <div className="flex">
                      <div className="">
                         <div className="nav-sub-title">BY ROLE</div>
                         <ul className="footer-navs">
                            <li><NavHashLink to={'/useCase'}>Marketing</NavHashLink></li>
                            <li><NavHashLink  to={'/sales'}>Sales</NavHashLink></li>
                            <li><NavHashLink to={'/customer-success'}>Customer success</NavHashLink></li>
                            <li><NavHashLink to={'./support'}>Support</NavHashLink></li>
                            <li><NavHashLink to={'./training'}>Training</NavHashLink></li>
                         </ul>
                      </div>
                      <div className="margin-l-30 padding-l-10">
                         <div className="nav-sub-title">BY USE CASES</div>
                         <ul className="footer-navs">
                            <li><a>Product walkthroughs</a></li>
                            <li><a>Sales enablement</a></li>
                            <li><a>Onboard customers</a></li>
                            <li><a>Drive product adoption</a></li>
                            <li><a>Update knowledge base</a></li>
                         </ul>
                      </div>
                   </div>
                </li>

                <li className="">
                   <div className="nav-title padding-b-10">Company</div>
                   <ul className="footer-navs">
                      <li><NavHashLink to={'/pricing'}>Pricing</NavHashLink></li>
                      <li><NavHashLink to={'/blogs'}>Blog</NavHashLink></li>
                   </ul>
                </li>

                <li className="">
                   <div className="nav-title padding-b-10">Contact us</div>
                   <ul className="footer-navs">
                      <li>
                         <a href="mailto:Vidya@floik.com" className="flex">
                            <div className="icon width-17">
                               <img src={mail} alt=""/>
                            </div>
                            <span className="margin-l-10">Vidya@floik.com</span>
                         </a>
                      </li>
                      <li>
                         <a href="tel:+91 23565 21367" className="flex">
                            <div className="icon width-17">
                               <img src={phone} alt=""/>
                            </div>
                            <span className="margin-l-10">+91 23565 21367</span>
                         </a>
                      </li>
                   </ul>
                </li>

             </ul>
          </div>
       </footer>
   )
}

export default Footer;
